import { render } from "./Tags.vue?vue&type=template&id=94ae70a4"
import script from "./Tags.vue?vue&type=script&lang=ts"
export * from "./Tags.vue?vue&type=script&lang=ts"
script.render = render

export default script